export { NGProviderBrowser } from "./NGProviderBrowser";
export type { NGProviderBrowserProps } from "./types";

/**
 * Format size value (memory, disk, storage) to appropriate display unit (Mi, Gi, Ti)
 * @param value - The size value
 * @param inputUnit - The unit of the input value: "Mi", "MB", "Gi", "GB", "Ti" (default: "Gi")
 */
export function formatSizeForProviderBrowser(
  value: number,
  inputUnit: "Mi" | "MB" | "Gi" | "GB" | "Ti" = "Gi",
): string {
  // Convert to Mi first (base unit for binary)
  let valueInMi: number;

  switch (inputUnit) {
    case "Mi":
    case "MB":
      valueInMi = value;
      break;
    case "Gi":
      valueInMi = value * 1024;
      break;
    case "GB":
      // 1 GB ≈ 953.674 Mi (decimal to binary conversion)
      valueInMi = value * 953.674;
      break;
    case "Ti":
      valueInMi = value * 1024 * 1024;
      break;
    default:
      valueInMi = value * 1024;
  }

  // Format to most appropriate unit
  if (valueInMi < 1024) {
    return `${Math.round(valueInMi)} Mi`;
  } else if (valueInMi < 1024 * 1024) {
    const gi = valueInMi / 1024;
    return `${gi >= 10 ? Math.round(gi) : gi.toFixed(1)} Gi`;
  } else {
    return `${(valueInMi / 1024 / 1024).toFixed(1)} Ti`;
  }
}
